import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import CustomHorizontalStepper from './CustomHorizontalStepper';
import pink_logo from '../../assets/pink_logo.png';
import steps from './steps';
const CompanyRegistrationForm :React.FC = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const companyRegistrationBoxStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '3.5%',
    padding: '35px',
    backgroundColor: 'white',
  }

  return (
    <>
    <Box sx={companyRegistrationBoxStyle}>
      {!isSmallScreen && <img src={pink_logo} alt="pink_logo" style={{width: '53px', position: 'absolute', left: 150, top: 20}}/>}
      <CustomHorizontalStepper steps={steps} />
    </Box>
    </>
  );
}

export default CompanyRegistrationForm;